export const splitArray = (array: any[], size: number) => {
    const result: any[] = [];
    for (let i = 0; i < array.length; i += size) {
        result.push(array.slice(i, i + size));
    }
    return result;
}
